import { IGrayBackgroundProps } from "./GrayBackground";

export const View = (props: IGrayBackgroundProps) => {
  return <div className="gray-bg">{props.children}</div>;
};
